/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_79de9198"]'><cube-button primary open-type="share" tip="需在小程序环境下预览">分享</cube-button></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_79de9198"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_79de9198"}
  /** script content **/
  require("./btn-share.mpx.js?isComponent&outputPath=components%2Fbtn-share79de9198%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./btn-share.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbtn-share79de9198%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_79de9198"],
    ctorType: "component",
    outputPath: "components/btn-share79de9198/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>